export const GET_COURSES_PREFERENCES = "GET_COURSES_PREFERENCES";
export const SET_COURSES_PREFERENCES_STATE = "SET_COURSES_PREFERENCES_STATE";
export const SAVE_COURSES_PREFERENCES_STATE = "SAVE_COURSES_PREFERENCES_STATE";
export const REGISTER_CHANGE = "REGISTER_CHANGE";
export const ERROR_MESSAGE = "ERROR_MESSAGE";
export const NAVIGATE_OFF = "NAVIGATE_OFF";
